import { render } from "./MyLibrary.vue?vue&type=template&id=37c83a71"
import script from "./MyLibrary.vue?vue&type=script&lang=ts"
export * from "./MyLibrary.vue?vue&type=script&lang=ts"
script.render = render

export default script